import Vue from 'vue';
import {
  BootstrapVue,
  BIcon,
  BIconstack,
  BIconPerson,
  BIconPersonPlus,
  BIconPower,
  BIconDownload,
  BIconTag,
  BIconCheck,
  BIconClipboard,
  BIconInfo,
  BIconArrowRight,
  BIconArrowLeft,
  BIconBuilding,
  BIconShieldLock,
  BIconCircle,
  BIconPersonDash,
  BIconPeople,
  BIconFunnel,
  BIconPlus,
  BIconFullscreen,
  BIconDash,
  BIconSquareFill,
  BIconArrowRepeat,
  BIconPlusCircle,
  BIconArrowClockwise,
  BIconAt,
  BIconLock,
  BIconUnlock,
  BIconInfoCircle,
  BIconLockFill,
  BIconAsterisk,
  BIconSearch,
  BIconCameraVideoOff,
  BIconSlash,
  BIconLink45deg,
  BIconFileEarmarkSpreadsheet
} from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.component('BIcon', BIcon);
Vue.component('BIconstack', BIconstack);
Vue.component('BIconPerson', BIconPerson);
Vue.component('BIconPersonPlus', BIconPersonPlus);
Vue.component('BIconPower', BIconPower);
Vue.component('BIconDownload', BIconDownload);
Vue.component('BIconTag', BIconTag);
Vue.component('BIconCheck', BIconCheck);
Vue.component('BIconClipboard', BIconClipboard);
Vue.component('BIconInfo', BIconInfo);
Vue.component('BIconArrowRight', BIconArrowRight);
Vue.component('BIconArrowLeft', BIconArrowLeft);
Vue.component('BIconBuilding', BIconBuilding);
Vue.component('BIconShieldLock', BIconShieldLock);
Vue.component('BIconCircle', BIconCircle);
Vue.component('BIconPersonDash', BIconPersonDash);
Vue.component('BIconPeople', BIconPeople);
Vue.component('BIconFunnel', BIconFunnel);
Vue.component('BIconPlus', BIconPlus);
Vue.component('BIconFullscreen', BIconFullscreen);
Vue.component('BIconDash', BIconDash);
Vue.component('BIconSquareFill', BIconSquareFill);
Vue.component('BIconArrowRepeat', BIconArrowRepeat);
Vue.component('BIconPlusCircle', BIconPlusCircle);
Vue.component('BIconArrowClockwise', BIconArrowClockwise);
Vue.component('BIconAt', BIconAt);
Vue.component('BIconLock', BIconLock);
Vue.component('BIconUnlock', BIconUnlock);
Vue.component('BIconInfoCircle', BIconInfoCircle);
Vue.component('BIconLockFill', BIconLockFill);
Vue.component('BIconAsterisk', BIconAsterisk);
Vue.component('BIconSearch', BIconSearch);
Vue.component('BIconCameraVideoOff', BIconCameraVideoOff);
Vue.component('BIconSlash', BIconSlash);
Vue.component('BIconLink45deg', BIconLink45deg);
Vue.component('BIconFileEarmarkSpreadsheet', BIconFileEarmarkSpreadsheet);
